module.exports = __webpack_public_path__ + "static/media/mask15.bbfb77c6.JPG";